'use client'

// React Imports
import { useState } from 'react'

// MUI Imports
import Box from '@mui/material/Box'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'

// Third-party Imports
import { Icon } from '@iconify/react'

// Component Imports
import CustomerLedgerWrapper from './CustomerLedgerWrapper'

const CustomerLedgerList = () => {
    const [view, setView] = useState('table')

    const handleViewChange = (event, nextView) => {
        if (nextView !== null) {
            setView(nextView)
        }
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

            
            <CustomerLedgerWrapper viewType={view} />
        </Box>
    )
}

export default CustomerLedgerList
